const NotBlogList = ['/', '/blog', '/about', '/imprint', '/contact', '/404', '/thanks']

const isNotBlogPost = (url) => {
  if (!NotBlogList.includes(url))
    return `/blog/${url}`
  else
    return url
}

export default isNotBlogPost;